const excludedPrefixes = ["/_nuxt", "/_ipx", "/api", "/.well-known"];

export default defineNuxtRouteMiddleware((to) => {
  const path = to.path || "";

  if (!path || path === "/" || path.endsWith("/")) {
    return;
  }

  if (excludedPrefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return;
  }

  // Skip file-like routes such as robots.txt or sitemap.xml.
  if (/\.[A-Za-z0-9]+$/.test(path)) {
    return;
  }

  return navigateTo(
    {
      path: `${path}/`,
      query: to.query,
      hash: to.hash,
    },
    {
      redirectCode: 301,
      replace: true,
    },
  );
});
